import { bem } from '@socialive/common';
import PropTypes from 'prop-types';
import './chat.css';
import ChatInput from './ChatInput';
import ChatScrollPane from './ChatScrollPane';
import { messageShape } from './shapes';

/*
#tailwind
*/

function Chat({ testId, onSend, messages, visible, placeholder, className, allowSend, title, ...other }) {
  const chatInputTestId = testId && `${testId}-chat-input`;

  return (
    <div className={bem`chat ${className}`} data-testid={testId} {...other}>
      {title && <div className="chat__title">{title}</div>}
      <div className="chat__content">
        <ChatScrollPane messages={messages} visible={visible} />
      </div>
      {!allowSend && (
        <>
          <div className="chat__divider" />
          <div className="chat__disabledMessage">Chat disabled by administrator</div>
        </>
      )}
      {allowSend && <ChatInput onSend={onSend} placeholder={placeholder} testId={chatInputTestId} />}
    </div>
  );
}

Chat.propTypes = {
  testId: PropTypes.string,
  onSend: PropTypes.func,
  messages: PropTypes.arrayOf(messageShape).isRequired,
  visible: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  allowSend: PropTypes.bool,
  title: PropTypes.string,
};

Chat.defaultProps = {
  testId: undefined,
  onSend: undefined,
  visible: true,
  placeholder: undefined,
  className: undefined,
  allowSend: true,
  title: undefined,
};

export default Chat;
